import { useEffect } from "react";

const Terms = () => {
  useEffect(() => {
    const scrollToHash = () => {
      const { hash } = window.location;
      if (!hash) {
        window.scrollTo(0, 0);
        return;
      }
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="container-main py-16">
        <h1 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
          Terms of Service
        </h1>
        <p className="text-slate-500 mb-8">Effective date: 22 Dec 2025</p>

        <div className="space-y-8 text-slate-600 leading-relaxed">
          <section id="agreement">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Agreement</h2>
            <p>
              By accessing or using AfriGulf Market, you agree to these Terms of Service and all applicable
              UAE laws and regulations.
            </p>
          </section>

          <section id="use-of-platform">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Use of the Platform</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>You must provide accurate information and keep your account secure.</li>
              <li>You are responsible for all activity under your account.</li>
              <li>You may not use the platform for unlawful or deceptive activity.</li>
            </ul>
          </section>

          <section id="listings-and-transactions">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Listings and Transactions</h2>
            <p>
              Suppliers are responsible for the accuracy of product listings. Buyers and suppliers are
              solely responsible for the terms of any transaction, subject to platform policies.
            </p>
          </section>

          <section id="intellectual-property">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Intellectual Property</h2>
            <p>
              All platform content and trademarks are owned by AfriGulf Market or its licensors and may
              not be used without permission.
            </p>
          </section>

          <section id="disclaimer">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Disclaimer</h2>
            <p>
              The platform is provided "as is" without warranties of any kind. We do not guarantee the
              availability of listings or outcomes of transactions.
            </p>
          </section>

          <section id="limitation-of-liability">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by UAE law, AfriGulf Market is not liable for indirect,
              incidental, or consequential damages arising from use of the platform.
            </p>
          </section>

          <section id="governing-law">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Governing Law</h2>
            <p>
              These terms are governed by the laws of the United Arab Emirates. Disputes will be resolved
              in UAE courts with appropriate jurisdiction.
            </p>
          </section>

          <section id="contact">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Contact</h2>
            <p>
              For legal questions, contact afrigulfmarket@proton.me.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;


